import { SmallDetailsStatus } from '@midocean/webapps-shared-domain';

export enum SmallDetailsProcessingResult {
  Ok = 1,
  TimeExceeded = 2,
  AreaTooSmall = 3,
  Error = 4,
}

export type SmallDetailsResult = {
  positiveDetailsLoss: number;
  negativeDetailsLoss: number;
  pngFile: string;
  calculatedQuality: number;
  id: string;
  operationStatus: SmallDetailsProcessingResult;
};

export type SmallDetailsPayload = Omit<
  SmallDetailsResult,
  'operationStatus'
> & {
  status: SmallDetailsStatus;
  approvedAt: string | undefined;
  pngFileBlob: Blob;
  isCheckValid: boolean;
};

export type CheckImageSmallDetailsCommand = {
  id: string;
  logoWidthInMm: number;
  positiveLimitInMm: number;
  negativeLimitInMm: number;
  ignoreColors: boolean;
};

export type ProcessTextCommand = {
  id: string;
  font: string;
  fontSize: number;
  isBold: boolean;
  isItalic: boolean;
  text: string;
  textColor: string;
  textAlignment: TextAlignment;
  productTechniqueGroupCode: string;
};

export type TextAlignment = 'Left' | 'Center' | 'Right';

export const DefaultSmallDetailsResult: SmallDetailsPayload = {
  isCheckValid: false,
  positiveDetailsLoss: 0,
  negativeDetailsLoss: 0,
  pngFile: '',
  calculatedQuality: 0,
  id: '',
  status: 'Good',
  approvedAt: undefined,
  pngFileBlob: new Blob(),
};

export type NewLogoImprovementRequestForm = {
  customerNumber: string;
  productSapCode: string;
  email: string;
  region: string;
  language: string;
  logos: NewLogoImprovementRequestLogoForm[];
};

export type NewLogoImprovementRequestLogoForm = {
  originalFileName: string;
  title: string;
  printTechniqueSapCode: string;
  printPositionSapCode: string;
  printSizeWidthMm: number;
  printSizeHeightMm: number;
  improvementOption: string;
  comment: string;
  improvementOptionKey: string;
};

export type Product3DPreviewResult = {
  pngFile: string;
  isRoundItem: boolean;
};

export type Product3DPreviewCommand = {
  productSKU: string;
  productName: string;
  variantColor: string;
  positionName: string;
  printPositionContent: PrintPositionPersonalizationContent;
};

export type ProductAIPreviewCommand = {
  productSKU: string;
  variantColor: string;
  positionCode: string;
  printTechniqueCode: string;
  printPositionContent: PrintPositionPersonalizationContent;
};

export type ProductAIPreviewResult = {
  pngFile: string;
  isPromptFound: boolean;
  isNanoBananaAvailable: boolean;
};

export type VectorizeResponse = {
  vectorizedContentBytes: string;
  imageToken: string;
  fileName: string;
};

export type PrintPositionPersonalizationContent = {
  widthInMM: number;
  heightInMM: number;
  personalizationArtworks: PersonalizationMember[];
  personalizationTexts: PersonalizationMember[];
};

export type PersonalizationMember = {
  distanceFromTop: number;
  distanceFromLeft: number;
  width: number;
  height: number;
  rotationAngle: number;
  fileName: string;
};
